import { FC } from "react";

import { useScrollToHashOnFirstRender } from "shared/utils";
import { Button } from "shared/components";
import { copy } from "shared/assets";
import { Plus } from "shared/assets/icons";
import { Icon } from "shared/styles";
import { useBandRoute } from "Bands/utils";
import { BAND_PATHS } from "Bands/router";

import { MembersTable, PendingInvitationsTable, SentInvitationsTable } from "./containers";
import { usePermissionsContext } from "Bands/contexts";

const { members: membersCopy } = copy;

export const MemberOverviewPage: FC = () => {
  const { userCanManageMembers } = usePermissionsContext();

  const { pushRoute } = useBandRoute();
  useScrollToHashOnFirstRender();

  return (
    <>
      {userCanManageMembers && (
        <Button onClick={() => pushRoute(BAND_PATHS.CREATE_MEMBER)} data-testid="add_member_button">
          <Icon as={Plus} />
          <span>{membersCopy.addButton.label}</span>
        </Button>
      )}

      <PendingInvitationsTable />
      <SentInvitationsTable />
      <MembersTable />
    </>
  );
};
